<template>
  <div class="game-container">
    <div id="game-container"><canvas id="gameCanvas"></canvas></div>
  </div>
</template>

<script>
import _ from 'lodash';
import createjs from 'createjs-collection';
import preload from 'preload-js';
export default {
  name: 'mp-draw-v2',
  components: {},
  props: {
    startGameConfig: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      initData: {},
      width: 0,
      height: 0,
      offset: {},
      stage: {},
      figureArea: {},
      touchArea: {},
      line: {},
      mousedown: false,
      images: [],
      point: {},
      lines: [],
    };
  },
  beforeMount() {},
  mounted() {
    this.initGame();
  },
  created() {},
  methods: {
    initGame() {
      var self = this;
      this.initData = this.startGameConfig;
      this.images = [];
      this.lines = [];
      this.width = document.getElementById('game-container').offsetWidth;
      this.height = document.getElementById('game-container').offsetHeight;
      this.stage = new createjs.Stage('gameCanvas');
      this.stage.canvas.width = this.width;
      this.stage.canvas.height = this.height;
      this.offset = {
        x: this.stage.canvas.width / 2,
        y: this.stage.canvas.height / 2,
      };
      this.stage.mouseMoveOutside = true;
      this.stage.x = this.offset.x;
      this.stage.y = this.offset.y;
      let queue = new preload.LoadQueue();
      queue.on('fileload', this.handleFileLoad);
      queue.on('complete', this.handleComplete);
      queue.loadManifest(this.initData.sample);
      this.point = new createjs.Shape();
      this.point.graphics.beginFill('rgba(0,0,0,0.3)').drawCircle(0, 0, 25);
      this.point.on('pressmove', function (e) {
        e.target.x = e.stageX - self.offset.x;
        e.target.y = e.stageY - self.offset.y;
        self.update();
      });
      this.point.visible = false;
      this.line = new createjs.Shape();
      this.stage.update();
      createjs.Touch.enable(this.stage);
      // console.log(createjs.Touch.isSupported());
    },
    newGame() {
      this.width = document.getElementById('game-container').offsetWidth;
      this.height = document.getElementById('game-container').offsetHeight;
      this.stage.canvas.width = this.width;
      this.stage.canvas.height = this.height;
      this.offset = {
        x: this.stage.canvas.width / 2,
        y: this.stage.canvas.height / 2,
      };
      this.stage.x = this.offset.x;
      this.stage.y = this.offset.y;
      var self = this;
      this.lines.forEach(function (item, i) {
        item.shape.graphics.clear();
        self.stage.removeChild(item.shape);
      });
      this.lines.splice(0, this.lines.length);
      this.images.forEach(function (item, i) {
        item.center.visible = false;
      });
      this.stage.update();
    },
    handleFileLoad(e) {
      var image = e.result;
      var w = image.width;
      var h = image.height;
      let bmp = new createjs.Bitmap(image.src);
      bmp.id = e.item.id;
      bmp.x = -this.width / 2 + e.item.cord.x;
      bmp.y = -this.height / 2 + e.item.cord.y;
      if (e.item.dim.w && e.item.dim.h) {
        bmp.scaleX = e.item.dim.w / w;
        bmp.scaleY = e.item.dim.h / h;
      } else if (e.item.dim.w && !e.item.dim.h) {
        bmp.scaleY = bmp.scaleX = e.item.dim.w / w;
      } else if (!e.item.dim.w && e.item.dim.h) {
        bmp.scaleX = bmp.scaleY = e.item.dim.h / h;
      }
      bmp.on('mousedown', this.stageMouseDown);
      bmp.on('pressup', this.stageMouseUp);
      bmp.center = new createjs.Shape();
      bmp.center.graphics.beginFill('rgba(0,0,0,0.3)').drawCircle(0, 0, 25);
      bmp.center.x = bmp.x;
      bmp.center.y = bmp.y;
      bmp.center.visible = false;
      bmp.points = [];
      this.images.push(bmp);
      this.stage.addChild(bmp, bmp.center);
    },
    handleComplete(e) {
      this.images.forEach(function (bmp, i) {
        bmp.center.x += bmp.getTransformedBounds().width / 2;
        bmp.center.y += bmp.getTransformedBounds().height / 2;
      });
      this.stage.addChild(this.line);
      this.stage.addChild(this.point);
      this.stage.update();
    },
    stageMouseDown(e) {
      var i = -1;
      this.images.forEach(function (bmp, j) {
        if (e.target.id == bmp.id) i = j;
      });
      if (i >= 0) {
        this.images[i].center.visible = true;
        this.stage.on('stagemousemove', this.stageMouseMove);
        this.point.x = e.stageX - this.offset.x;
        this.point.y = e.stageY - this.offset.y;
        this.point.visible = true;
        this.point.start = i;
        this.mousedown = true;
      }
      this.stage.update();
    },
    stageMouseMove(e) {
      if (this.mousedown) {
        var pos = {
          x: e.stageX - this.offset.x,
          y: e.stageY - this.offset.y,
        };
        this.update(pos);
      }
    },
    stageMouseUp(e) {
      this.mousedown = false;
      this.point.visible = false;
      this.line.graphics.clear();
      var draw = -1;
      var self = this;
      var i = -1;
      this.stage.getObjectsUnderPoint(self.point.x, self.point.y).forEach(function (bmp) {
        self.images.forEach(function (indx, j) {
          if (indx.id == bmp.id) i = j;
        });
      });
      if (i >= 0 && i != this.point.start) {
        this.images[i].center.visible = true;
        this.lines.forEach(function (item, j) {
          if (item.points.indexOf(i) != -1 && item.points.indexOf(self.point.start) != -1) draw = j;
        });
        var line = {};
        if (draw == -1) line.shape = new createjs.Shape();
        else line = this.lines[draw];
        line.shape.graphics
          .clear()
          .s('black')
          .ss(2, 'round')
          .mt(this.images[i].center.x, this.images[i].center.y)
          .lt(this.images[this.point.start].center.x, this.images[this.point.start].center.y);
        line.points = [i, this.point.start];
        line.block = false;
        line.correct = false;
        this.lines.push(line);
        if (draw == -1) this.stage.addChild(line.shape);
      }
      this.stage.update();
      this.stage.removeAllEventListeners('stagemousemove');
    },
    update(newPos) {
      this.line.graphics
        .clear()
        .s('blue')
        .ss(2, 'round')
        .mt(this.images[this.point.start].center.x, this.images[this.point.start].center.y)
        .lt(newPos.x, newPos.y);
      this.point.x = newPos.x;
      this.point.y = newPos.y;
      this.stage.update();
    },
    resetGameAction() {
      this.newGame();
    },
    checkGameAction() {
      var isCorrect = true;
      return isCorrect;
    },
    resetCheckStatus() {
      this.$store.dispatch('resetCheckStatus');
      return true;
    },
  },
  beforeDestroy() {
    this.stage.removeAllEventListeners();
  },
  computed: {
    checkGame() {
      return this.$store.getters.checkGame;
    },
    resetGameSwitch() {
      return this.$store.getters.resetGame;
    },
  },
  watch: {
    checkGame: function (newStatus, oldStatus) {
      if (newStatus) {
        this.$store.dispatch('checkGame', this.checkGameAction());
        this.$store.commit('CHECK_GAME', false);
      }
    },
    resetGameSwitch(newStatus, oldStatus) {
      // // console.log('newStatus', newStatus);
      if (newStatus) {
        this.resetGameAction();
        this.$store.dispatch('resetGame');
      }
    },
  },
};
</script>
<style lang="scss"></style>
<style lang="scss" scoped>
.game-container {
  display: flex;
  padding: 160px 50px 100px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  border: 1px solid black;
}

#game-container {
  margin: 0;
  border: 1px solid green;
  width: 100%;
  height: 100%;
}

canvas {
  border: 1px solid red;
}
</style>
